import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PublicService {
  constructor(private readonly _httpClient: HttpClient) {}

  public getStats(prefix: string): Observable<any> {
    return this._httpClient.get(`/api/public/organizations/${prefix}/stats/`);
  }
}
